import C from 'actionTypes'

export const goOnboardingGettingStarted = () => ({
  type: C.ONBOARDING_GETTING_STARTED
})

export const goOnboardingContacts = (financialAccountId, financialAccountType, contactType) => ({
  type: C.ONBOARDING_CONTACTS_PAGE,
  payload: {
    financialAccountId,
    financialAccountType,
    contactType
  }
})

export const goOnboardingEmployerInformation = (financialAccountId, financialAccountType) => ({
  type: C.ONBOARDING_EMPLOYER_INFORMATION,
  payload: {
    financialAccountId,
    financialAccountType,
  }
})

export const goOnboardingAdditionalDetails = (financialAccountId, financialAccountType) => ({
  type: C.ONBOARDING_ADDITIONAL_DETAILS,
  payload: {
    financialAccountId,
    financialAccountType,
  }
})

export const goOnboardingAddContact = payload => ({
  type: C.ONBOARDING_ADD_CONTACT,
  payload
})

export const goOnboardingEditContact = (...params) => {
  const [financialAccountId, financialAccountType, contactType, contactId] = params
  return {
    type: C.ONBOARDING_EDIT_CONTACT,
    payload: {
      financialAccountId,
      financialAccountType,
      contactType,
      contactId
    }
  }
}

export const goAboutYou = () => ({
  type: C.ONBOARDING_ABOUT_YOU
})

export const goOnboardingPersonalInformation = () => ({
  type: C.ONBOARDING_PERSONAL_INFORMATION
})

export const goOnboardingEmploymentDetails = () => ({
  type: C.ONBOARDING_EMPLOYMENT_DETAILS
})

export const goOnboardingIdentityVerification = () => ({
  type: C.ONBOARDING_IDENTITY_VERIFICATION
})

export const goOnboardingYourAccounts = () => ({
  type: C.ONBOARDING_YOUR_ACCOUNTS
})

export const goOnboardingAccountDetails = (financialAccountId, financialAccountType) => ({
  type: C.ONBOARDING_ACCOUNT_DETAILS,
  payload: { financialAccountId, financialAccountType },
})

export const goOnboardingJointAccountHolder = (financialAccountId, financialAccountType) => ({
  type: C.ONBOARDING_JOINT_OWNER,
  payload: {
    financialAccountId,
    financialAccountType,
  }
})

export const goOnboardingReviewAndSubmit = () => ({
  type: C.ONBOARDING_REVIEW_AND_SUBMIT
})

export const goOnboardingConfirmation = () => ({
  type: C.ONBOARDING_CONFIRMATION
})

export const goSecureDocumentUploaderPage = () => ({
  type: C.SECURE_DOC_UPLOADER_PAGE
})

export const goErrorPage = () => ({
  type: C.ERROR_PAGE
})

export default {
  goOnboardingGettingStarted,
  goOnboardingContacts,
  goOnboardingAddContact,
  goOnboardingEditContact,
  goAboutYou,
  goOnboardingPersonalInformation,
  goOnboardingEmploymentDetails,
  goOnboardingIdentityVerification,
  goOnboardingYourAccounts,
  goOnboardingAccountDetails,
  goOnboardingReviewAndSubmit,
  goOnboardingConfirmation,
  goSecureDocumentUploaderPage,
  goErrorPage,
  goOnboardingJointAccountHolder,
  goOnboardingEmployerInformation,
  goOnboardingAdditionalDetails,
}



// WEBPACK FOOTER //
// ./src/actions/routing.js